import { CountryItem, IndustryItem, SublistItem } from '@type/common';
import { NewsAndStoriesFilter, NewsAndStoriesTopicsElement } from './NewsAndStories.types';
import { optionallySetSearchParams } from '@helpers/URLHelpers';

export const getItemFromList = (
  id: string,
  list: { Id: string; Name: string }[]
): { Id: string; Name: string } => {
  for (const subListItem of list) {
    if (subListItem.Id === id) {
      return subListItem;
    }
  }
};

// If 2 response with same id it will show last response name in filter
export const getItemFromSubList = (
  id: string,
  list: CountryItem[] | IndustryItem[] | SublistItem[],
  subListName: string
): SublistItem => {
  for (const item of list) {
    if (item[subListName]) {
      const subListItem = item[subListName].filter((subListItem) => subListItem.Id == id).at(-1);
      if (subListItem) {
        return subListItem;
      }
    }
  }
};

export const setURLfromFilters = (f: NewsAndStoriesFilter) => {
  const url = new URL(window.location.href);
  optionallySetSearchParams(url, 'keyword', f.searchString);
  optionallySetSearchParams(url, 'country', f.country?.Id);
  optionallySetSearchParams(url, 'industries', f.industry?.Id);
  optionallySetSearchParams(url, 'category', f.category?.Id);
  optionallySetSearchParams(url, 'year', f.year);

  window.history.pushState({}, null, url);
};

export const resetURL = () => {
  const url = new URL(window.location.href);
  window.history.pushState({}, null, url.origin + url.pathname);
};

export const shouldDefaultOpenFilter = (filter: NewsAndStoriesFilter): boolean => {
  /* All filter values are set to falsey values if the filter is empty */
  const { searchString, ...advancedFilters } = filter;
  return Object.values(advancedFilters).some(Boolean);
};

export const getFiltersFromURL = (): NewsAndStoriesFilter => {
  const url = new URL(window.location.href);
  return {
    searchString: url.searchParams.get('keyword') || '',
    country: url.searchParams.get('country')
      ? {
          Id: url.searchParams.get('country') || '',
          Name: undefined,
        }
      : undefined,
    industry: url.searchParams.get('industries')
      ? {
          Id: url.searchParams.get('industries'),
          Name: undefined,
        }
      : undefined,
    category: url.searchParams.get('category')
      ? { Id: url.searchParams.get('category'), Name: undefined }
      : undefined,
    year: url.searchParams.get('year') ? +url.searchParams.get('year') : undefined,
  };
};

export const isNewsAndStoriesTopicsBlock = (item: any): item is NewsAndStoriesTopicsElement => {
  return item.isTopics === true;
};
